import React, { useState, useRef, useEffect } from 'react';
import './ChatPage.css';
import axios from "axios";
import {useParams} from "react-router";
import {Box, Button} from "@mui/material";
import AnimateButton from "../../ui-component/extended/AnimateButton"; // Import CSS file for styling

const ChatPage = () => {
    const {id} = useParams();
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const messagesEndRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    useEffect(() => {
        // Scroll to the bottom of the chat window whenever new message is added
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputValue.trim() !== '') {
            appendMessage(inputValue);
        }
    };

    useEffect(() => {
        getMessages();
    }, [id]);


    function getMessages() {
        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                }
            }
            setLoading(true);
            const response = axios.get("/api/Ai/GetSession/" + id, config);
            response.then(x => {
                setLoading(false);
                setMessages(x.data.messages);
            })
        } catch (error) {
            console.error("Save failed", error);
        }
    }
    function appendMessage(message) {
        try {
            setInputValue('Sending ...');
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                }
            }
            setLoading(true);
            setIsSubmitting(true);
            const body = JSON.stringify({
                sessionId:id,
                message: message
            })
            const response = axios.post("/api/Ai/Chat", body , config);
            response.then(x => {
                setInputValue('');
                setLoading(false);
                setIsSubmitting(false);
                const newMessages = [...messages, {
                    message:message
                },{
                    isAssistant:true,
                    message:x.data.message
                }];
                setMessages(newMessages);
            })
        } catch (error) {
            console.error("Save failed", error);
            setInputValue('');
        }
    }
    
    return (
        <div className="chat-container">
            <div className="chat-window">
                {messages.map((message, index) => (
                    <div key={index} className={`message ${message.isAssistant ? "bot" : "user"}`}>
                        {message.message}
                    </div>
                ))}
                <div ref={messagesEndRef} />
            </div>
            <form onSubmit={handleSubmit} className="input-form">
                <input
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder="Type your message..."
                />
                <Box sx={{ ml: 2 }}>
                    <AnimateButton>
                        <Button disableElevation disabled={isSubmitting} type="submit" variant="contained" color="secondary">
                            Send
                        </Button>
                    </AnimateButton>
                </Box>
            </form>
        </div>
    );
};

export default ChatPage;